import styled from 'styled-components';

import { Carousel } from '@xing-com/carousel';
import { Divider } from '@xing-com/divider';
import { GridItem } from '@xing-com/grid';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { SkeletonHeadline, SkeletonBody } from '@xing-com/skeleton';
import {
  scale000,
  scale100,
  space3XL,
  space4XL,
  spaceL,
  spaceM,
  spaceS,
  spaceXL,
  spaceXXL,
} from '@xing-com/tokens';

const StyledSkeletonHeadline = styled(SkeletonHeadline)`
  margin: ${space3XL} ${scale000} ${scale100};

  @media ${mediaSmallOrTiny} {
    margin: ${space3XL} ${scale000} ${spaceM};
  }
`;

const StyledSkeletonBodyCopy = styled(SkeletonBody)`
  margin-bottom: ${spaceS};
`;

const StyledGridItem = styled(GridItem)`
  margin: -${spaceL} ${scale000};
`;

const StyledSkeletonCarouselHeadline = styled(SkeletonHeadline)`
  margin-top: ${space4XL};

  @media ${mediaSmallOrTiny} {
    margin-top: ${space3XL};
  }
`;

const StyledCarousel = styled(Carousel)`
  margin-top: ${spaceXL};

  @media ${mediaSmallOrTiny} {
    margin-top: ${spaceL};
  }
`;

const StyledDivider = styled(Divider)`
  margin: ${space3XL} ${scale000} ${space4XL};

  @media ${mediaSmallOrTiny} {
    margin: ${spaceXXL} ${scale000} ${space3XL};
  }
`;

export const Styled = {
  SkeletonHeadline: StyledSkeletonHeadline,
  SkeletonBodyCopy: StyledSkeletonBodyCopy,
  GridItem: StyledGridItem,
  SkeletonCarouselHeadline: StyledSkeletonCarouselHeadline,
  Carousel: StyledCarousel,
  Divider: StyledDivider,
};
